import { render } from "./DonationAmountPicker.vue?vue&type=template&id=2c366abb"
import script from "./DonationAmountPicker.vue?vue&type=script&lang=js"
export * from "./DonationAmountPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__